import mitt from 'mitt';

/**
 * @typedef {{
 *  openingScanner: QRScannerStatus;
 *  closingScanner: void;
 *  [key: string]: unknown;
 * }} EventBusEvents
 */

/** @type {import('mitt').Emitter<EventBusEvents>} */
const eventBus = mitt();

export default eventBus;
